/** Keep in sync with seal-domain SealUiUrls.java */
export const FOCUS_COMPONENT_PARAM = "focusComponent";

export const FOCUS_FINDING_PARAM = "focusFinding";

export const SBOM_VULNERABLE_TAB_HASH = "vulnerable";

export function sbomFocusedFindingPath(
    projectId: string,
    projectVersionId: string,
    componentId: string,
    findingId: string,
): string {
    return `sbom-projects/${projectId}/${projectVersionId}`
        + `?${FOCUS_COMPONENT_PARAM}=${componentId}`
        + `&${FOCUS_FINDING_PARAM}=${findingId}`
        + `#${SBOM_VULNERABLE_TAB_HASH}`;
}